var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doctor"},[_c('DoctorList',{attrs:{"doctor-list":_vm.doctorList,"hylx":_vm.hylx}}),_c('Brand')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }